import script from "./ProfileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileModal.vue?vue&type=script&setup=true&lang=js"

import "./ProfileModal.vue?vue&type=style&index=0&id=04a0b4bd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04a0b4bd"]])

export default __exports__